/** @format */
import {useLocation, useNavigate} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {Tabs, Tab} from '@sttark/design-system';

// styles
import './orders_nav.scss';

export const PreferencesNav = ({children}) => {
    const [activeTab, setActiveTab] = useState();
    const navigate = useNavigate();
    const location = useLocation();

    const onChangeTab = tab => {
        navigate(tab);
    };

    useEffect(() => {
        const currentPath = location.pathname;
        setActiveTab(currentPath);
    }, [location]);

    return (
        <div className="orders-nav-37ju">
            <Tabs activeTab={activeTab} onChange={onChangeTab} className={'tabs mb-0'}>
                <Tab title={`Contact`} name="/account/users/account-details/contact" />
                <Tab title={`Addresses`} name="/account/users/addresses" />
                <Tab title={`Billing`} name="/account/users/payments" />
                <Tab
                    title={`Production Presets`}
                    name="/account/users/account-details/production-presets"
                />
            </Tabs>

            <section>{children}</section>
        </div>
    );
};
